<template>
    <v-popover offset="0" :open="isOpen" trigger="click" :autoHide="true" v-on:auto-hide="close">
        <span class="tooltip-target badge pointer badge-warning badge_health_insurance" role="button" @click="open"><i class="fa fa-warning" aria-hidden="true"></i> chybí zdrav. pojišťovna</span>
        <template slot="popover">
    <div class="container" v-if="!insuranceCompaniesPending">
        <div class="row">
            <div class="col-sm-12"><h6>Výběr zdravotního pojištění</h6></div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <form @submit.prevent="postInsurance(clientId)">
                    <div class="form-group">
                        <label for="insuranceCompanySelect">Zdravotní pojišťovna</label>
                        <select class="form-control" v-model="insurance.insurance_company" id="insuranceCompanySelect">
                            <option v-for="ic in insuranceCompanies" v-bind:value="ic.code">{{ ic.code }} - {{ ic.shortcut }} - {{ ic.name }}</option>
                        </select>
                    </div>
                    <button v-if="!insurancePending" type="submit" class="btn btn-success btn-sm">Uložit</button>
                    <button class="btn btn-primary btn-sm disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                </form>
            </div>
        </div>
    </div>
    </template>
    </v-popover>
</template>

<script>
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        isOpen: false,
        insuranceCompaniesPending: true,
        insurance: {
          insurance_company: null
        },
        insurancePending: false
      }
    },
    mixins: [apiMixin],
    props: ['clientId'],
    methods: {
      open () {
        this.isOpen = true
      },
      close () {
        this.isOpen = false
      }
    },
    watch: {
      isOpen (val) {
        console.log(this.isOpen)
        if (val === true) {
          this.getInsuranceCompanies()
        } else {
          this.insuranceCompaniesPending = true
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .input-group.input-group-unstyled input.form-control {
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
    }
    .input-group-unstyled .input-group-addon {
        border-radius: 4px;
        border: 0px;
        background-color: transparent;
    }
    .row_description {
    }
    .row_description > td {
        padding-bottom: 1px;
        border: none;
        font-size: smaller;
    }
    .row_data {
    }
    .row_data > td {
        padding-top: 0px;
        font-weight: bold;
        font-size: large;
        border: none;
    }

    .width_fix {
        width: 100%;
    }
    .label_like {
        max-width: 100%;
        /*font-weight: bold;*/
    }
    .main_attribute {
        max-width: 100%;
        font-size: x-large;
        font-weight: bold;
    }

    .custom_panel_heading {
        border-bottom: none;
        padding-bottom: 0;
        background-color: #b5e3cf;
    }

    .custom_panel_heading .nav-tabs {
        border-bottom: none;
    }

    .custom_panel_heading .nav-tabs > li > a {
        background-color: #fff;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(odd) {
        margin-right: 0;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(even) {
        margin-left: 0;
    }

    /*modal insurance*/

    tr.valid_line {
        font-weight: bold;
    }

    .modal_default {
        overflow: visible !important;
    }

    table.table td {
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/Client/components/ClientSelectInsurance.vue?5c85a43a